/**
 * Client Portal API
 * Client Portal OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AuditLogRequest} from '../models/AuditLogRequest';
import type {AuditLogResponse} from '../models/AuditLogResponse';
import type {Error} from '../models/Error';

export interface GetUserAuditLog$Request {
    userId: number;
    auditLogRequest: AuditLogRequest;
}

export interface GetUserAuditLog$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserAuditLogRequest = createAction<PayloadData<void, GetUserAuditLog$Request>>('USER_AUDIT__GET_USER_AUDIT_LOG__REQUEST');
export const getUserAuditLogSuccess = createAction<PayloadData<AuditLogResponse, GetUserAuditLog$Request>>('USER_AUDIT__GET_USER_AUDIT_LOG__SUCCESS');
export const getUserAuditLogFailure = createAction<PayloadData<Error, GetUserAuditLog$Request, true>>('USER_AUDIT__GET_USER_AUDIT_LOG__FAILURE');

export const getUserAuditLogActions = [
    getUserAuditLogRequest,
    getUserAuditLogSuccess,
    getUserAuditLogFailure
] as const;

/**
 * Get audit log entries for a portal user
 * @param {number} meta.userId
 * @param {AuditLogRequest} meta.auditLogRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserAuditLog = (meta: GetUserAuditLog$Request, config?: GetUserAuditLog$Config) => {
    return {
        CALL_API: {
            types: getUserAuditLogActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/${meta.userId}/audit-log`,
            TRANSPORT_REQUEST_BODY: meta.auditLogRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

